import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=7f07150a&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=7f07150a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07150a",
  null
  
)

export default component.exports